import { HighlightOffOutlined, Schedule, WorkOutlineOutlined, } from "@mui/icons-material";
import { Stack, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { CalendarEvent } from "../types";

interface Props {
  event: CalendarEvent;
}

export const CalendarEventComponent = ({ event }: Props) => {
  const { t } = useTranslation("talentProfile");
  const isSmallScreen = useMediaQuery("(max-width:1600px)");
  const isWorktime = event.type === "WorktimeEntry";
  const isPartialDayUnavailability =
    event.type === "UnavailabilityEntry" &&
    event.unavailabilityType === "partialDay";

  const Icon = isWorktime
    ? WorkOutlineOutlined
    : isPartialDayUnavailability
      ? Schedule
      : HighlightOffOutlined;

  const startTime = format(event.start, "HH:mm");
  const endTime = format(event.end, "HH:mm");

  const showTimeRange =
    event.type === "WorktimeEntry" ||
    (event.type === "UnavailabilityEntry" &&
      event.unavailabilityType === "partialDay");

  const label = showTimeRange
    ? `${t(event.titleKey, event.titleParams)} ${t("calendar.timeRange", {
        start: startTime,
        end: endTime,
      })}`
    : t(event.titleKey, event.titleParams);

  return (
    <Stack
      className={`calendar-event-${event.type.toLowerCase()}`}
      direction="row"
      alignItems="center"
      gap={0.5}
      sx={{
        px: 0.5,
        py: 0.5,
        height: "100%",
        overflow: "hidden",
        borderRadius: "14px",
      }}
    >
      <Icon sx={{ fontSize: 14, flexShrink: 0 }} />
      <Tooltip title={label} disableHoverListener={!isSmallScreen}>
        <Typography
          sx={{
            fontSize: "14px",
            lineHeight: 1.2,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {label}
        </Typography>
      </Tooltip>
    </Stack>
  );
};
